<template>
    <div class="image-with-descriptions  overflow-hidden" :class="['my-5']">
        <img
            v-if="options.image"
            class="image-with-descriptions__image"
            :src="$i18n.locale + '/images/' + options.image"
        />
         <img
            v-if="options.image2"
            class="image-with-descriptions__image2"
            :src="$i18n.locale + '/images/' + options.image2"
        />
        <img
            v-if="options.image300"
            class="image-with-descriptions__image300"
            :src="$i18n.locale + '/images/' + options.image300"
        />
        <img
            v-if="options.image500"
            class="image-with-descriptions__image500"
            :src="$i18n.locale + '/images/' + options.image500"
        />
        <img
            v-if="options.imageFullWidth"
            class="image-with-descriptions__imageFullWidth"
            :src="$i18n.locale + '/images/' + options.imageFullWidth"
        />
        <img
            v-if="options.backgroungImageNewChapter"
            class="image-with-descriptions__backgroungImageNewChapter"
            :src="$i18n.locale + '/images/' + options.backgroungImageNewChapter"
        />

        <template
            v-for="(description, idx_description) in options.descriptions"
        >
            <span
                class="image-with-descriptions__description"
                :class="[
                    'image-with-descriptions__' +
                        description.position +
                        '-' +
                        description.orientation,
                    (description.color && description.color) || `text-white`,
                    (description.fontSize && description.fontSize) || `text-sm`,
                ]"
                v-html="description.text"
                :key="idx_description"
            ></span>
        </template>
    </div>
</template>

<script>
export default {
    name: "ImageWithDescriptions",
    props: {
        options: null,
    },
};
</script>

<style scoped lang="scss">
.image-with-descriptions {

    @apply relative block w-full;

    &__image {
        @apply relative block w-full;
    }
    &__image2 {
        @apply relative block w-full h-full;
    }
    &__image300 {
        @apply relative block w-full;
        min-height: 300px;
    }
    &__image500 {
        @apply relative block w-full;
        min-height: 500px;
        object-fit: cover;
    }
    &__imageFullWidth {
        @apply relative block w-full;
        min-height: 500px;
        max-height: 700px;
        object-fit: cover;
    }
    &__backgroungImageNewChapter {
        @apply relative w-full;
        height: 100vh;
        background-position: center;
        background-size: cover;
        object-fit: cover;
    }

    &__description {
        @apply absolute  top-0 left-0;
    }

    &__top {
        &-center {
            &-horizontal {
                @apply top-4 left-4 lg:top-10 md:left-44 lg:left-12 text-left bottom-auto right-12 md:right-44 lg:right-12 transform rotate-0 origin-top-left;
            }
            &-horizontal-custom-1 {
                @apply top-4 left-4 lg:top-10 md:left-8 lg:left-12 text-left bottom-auto right-12 md:right-12 lg:right-20 transform rotate-0 origin-top-left;
            }

            &-vertical {
                @apply top-2 left-12 md:left-44 lg:left-12 text-left bottom-auto right-12 md:right-44 lg:right-12 transform -rotate-90 origin-top-right -translate-x-full mt-7;
            }
        }
        &-left {
            &-horizontal {
                @apply top-4 left-4 bottom-auto right-auto transform rotate-0 text-left origin-top-left;
            }

            &-vertical {
                @apply top-1 left-1 bottom-auto right-auto transform -rotate-90 text-left origin-top-right -translate-x-full mt-7;
            }
        }

        &-right {
            &-horizontal {
                @apply top-1 right-1 bottom-auto left-auto transform rotate-0 text-right  origin-top-right;
                @media (max-width: 767px) {
                    font-size: 10px;
                    line-height: 1;
                }
            }

            &-vertical {
                @apply top-1 right-1 bottom-auto left-auto transform -rotate-90 text-right  origin-bottom-right;
            }
        }
    }

    &__bottom {
        &-left {
            &-horizontal {
                @apply bottom-4 left-4 top-auto right-auto transform rotate-0 text-left origin-top-left;
            }

            &-vertical {
                @apply bottom-1 left-1 top-auto right-auto transform -rotate-90 text-left origin-top-left;
            }
        }

        &-right {
            &-horizontal {
                @apply bottom-4 right-4 top-auto left-auto transform rotate-0 text-right origin-top-left;
            }

            &-vertical {
                @apply bottom-1 right-1 top-auto left-auto transform -rotate-90 text-right origin-bottom-left translate-x-full mb-7;
            }
        }
    }
}
</style>
